import client from './client';

export const getMedia = async (params = {}) => {
  const response = await client.get('/media', { params });
  return response.data;
};

export const getMediaById = async (uuid) => {
  const response = await client.get(`/media/${uuid}`);
  return response.data.media;
};

export const uploadMedia = async (formData) => {
  const response = await client.post('/media', formData);
  return response.data.media;
};

export const updateMedia = async (uuid, data) => {
  const response = await client.put(`/media/${uuid}`, data);
  return response.data.media;
};

export const deleteMedia = async (uuid) => {
  const response = await client.delete(`/media/${uuid}`);
  return response.data;
};

export const getTopics = async () => {
  const response = await client.get('/topics');
  return response.data.topics;
};

export const createTopic = async (name) => {
  const response = await client.post('/topics', { name });
  return response.data.topic;
};

export const updateTopic = async (id, name) => {
  const response = await client.put(`/topics/${id}`, { name });
  return response.data.topic;
};

export const deleteTopic = async (id) => {
  const response = await client.delete(`/topics/${id}`);
  return response.data;
};

export const getUsers = async () => {
  const response = await client.get('/users');
  return response.data.users;
};

export const createUser = async (data) => {
  const response = await client.post('/users', data);
  return response.data.user;
};

export const updateUser = async (id, data) => {
  const response = await client.put(`/users/${id}`, data);
  return response.data.user;
};

export const deleteUser = async (id) => {
  const response = await client.delete(`/users/${id}`);
  return response.data;
};

export const backfillDimensions = async () => {
  const response = await client.post('/media/backfill-dimensions');
  return response.data;
};

export const getSiteContent = async () => {
  const response = await client.get('/content');
  return response.data.content;
};

export const updateSiteContent = async (key, value) => {
  const response = await client.put(`/content/${key}`, { value });
  return response.data.content;
};

export const revertSiteContent = async () => {
  const response = await client.post('/content/revert');
  return response.data;
};

export const getUnregisteredFiles = async () => {
  const response = await client.get('/media/unregistered');
  return response.data.files;
};

export const registerMedia = async (data) => {
  const response = await client.post('/media/register', data);
  return response.data.media;
};

export const deleteUnregisteredFile = async (filename) => {
  const response = await client.delete(`/media/unregistered/${encodeURIComponent(filename)}`);
  return response.data;
};

export const downloadMedia = (uuid) => {
  const a = document.createElement('a');
  a.href = `/api/media/${uuid}/download`;
  a.download = '';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
};
